// extracted by mini-css-extract-plugin
export default {"file_remove":"filepicker_file_remove__Cldd7","spinner_list":"filepicker_spinner_list__Po9N5","spinner":"filepicker_spinner__7qplR"};